import { useState } from "react";
import { Bluetooth, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { readTemperatureFromBluetooth, isBluetoothAvailable } from "@/lib/bluetoothThermometer";

/**
 * Small button that reads a temperature from a paired Bluetooth thermometer
 * (Health Thermometer GATT service). Calls onRead(celsius) on success.
 */
export default function BluetoothTempButton({ onRead, testId = "bt-thermo-btn" }) {
  const [busy, setBusy] = useState(false);
  const available = isBluetoothAvailable();

  const read = async () => {
    setBusy(true);
    try {
      toast.info("Take a reading on the thermometer…");
      const celsius = await readTemperatureFromBluetooth();
      onRead && onRead(String(celsius));
      toast.success(`Got ${celsius}°C from your thermometer ♡`);
    } catch (err) {
      const msg = err?.message || "Bluetooth read failed";
      // User-cancelled prompts throw NotFoundError — stay quiet
      if (err?.name !== "NotFoundError") toast.error(msg);
    } finally { setBusy(false); }
  };

  if (!available) return null;
  return (
    <button
      type="button"
      onClick={read}
      disabled={busy}
      data-testid={testId}
      title="Sync from Bluetooth thermometer"
      className="kawaii-btn text-[11px] px-2.5 py-1 rounded-full font-body font-semibold border bg-white border-kawaii-lavender/60 text-kawaii-text inline-flex items-center gap-1.5 disabled:opacity-60"
    >
      {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Bluetooth className="w-3 h-3" strokeWidth={2.5} />}
      Sync
    </button>
  );
}
